window.addEventListener('load', function(){

	$('#loading-page').fadeOut(600, function() {
	});

	$(window).trigger('scroll');
});